import useMediaQuery from "./useMediaQuery";

export const useIsPhone = () => useMediaQuery('(max-width: 768px)');
export const useIsTablet = () => useMediaQuery('(max-width: 991px)');
export const useIsDesktop = () => useMediaQuery('(min-width: 992px)');
